<template>
  <v-container fluid pa-0 ma-0 v-if="isLoggedIn">
    <v-title>Order Status</v-title>
    <v-card>
      <v-card-text>
        <v-layout row wrap v-if="customer.customer">
          <v-flex sm1 md1 lg1>
            <v-text-field
              title="'Status: '+ rows[0].orderStatus"
              label="Order:"
              :value="`${rows[0].orderID}(${rows[0].orderStatus})`"
              disabled
              v-if="rows[0]"
            ></v-text-field>
          </v-flex>
          <v-flex sm2 md2 lg2>
            <v-text-field
              label="Vonex account number:"
              v-model="customer.customer.ubAccountNo"
              disabled
              v-if="customer.customer.ubAccountNo"
            ></v-text-field>
          </v-flex>
          <v-flex sm3 md3 lg3>
            <v-text-field
              label="Customer name:"
              v-model="customer.customer.firstName"
              disabled
              v-if="customer.customer.firstName"
            ></v-text-field>
          </v-flex>
          <v-flex sm3 md3 lg3>
            <v-text-field
              label="Customer Surname:"
              v-model="customer.customer.surname"
              disabled
              v-if="customer.customer.surname"
            ></v-text-field>
          </v-flex>
          <v-flex sm3 md3 lg3>
            <v-text-field
              label="Company:"
              v-model="customer.customer.companyDetails.companyName"
              disabled
              v-if="customer.customer.companyDetails"
            ></v-text-field>
          </v-flex>
          <v-flex sm12 md12 lg12 v-show="$route.name === 'appStatus'">
            <blockquote>
              To add products to this order,
              please select the appropriate links from the left menu
            </blockquote>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const {
  mapState: mapOrderState,
  mapGetters: mapOrderGetters
} = createNamespacedHelpers(`orders`);

export default {
  name: "AppStatus",
  computed: {
    ...mapOrderState(["auth", "customer", "dealer", "rows"]),
    ...mapOrderGetters(["isLoggedIn", "hasDealer", "hasOrder", "isAdmin"])
  }
};
</script>
